/* eslint-disable max-len */
import { NgModule } from '@angular/core';
import { Routes } from '@angular/router';
import { ErrorComponent } from './components/error/error.component';
import { UnauthorizedQualifiersComponent } from './components/unauthorized-qualifiers/unauthorized-qualifiers.component';
import { AuthCallbackComponent } from './auth/auth-callback.component';
import { AuthComponent } from './auth/auth.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { LogoutComponent } from './components/logout/logout.component';
import { AuthGuard } from './auth/auth.guard';
import { Entitlements } from './entitlements/entitlements';
import { AlertsDetailsComponent } from './components/alerts/details/alerts-details.component';
import { PayInfoComponent } from './components/pay-info/pay-info.component';
import { ElementRoutingModule } from './elements-routing/element-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { Header } from './components/header/header.model';
import { environment } from '../environments/environment';
import { RouterPopstatePreventer } from './elements-routing/router-popstate-preventer.service';
import { StaleDatedChecksInfoComponent } from './components/stale-dated-checks-info/stale-dated-checks-info.component';
import { CompanyInfoComponent } from './components/company-info/company-info.component';
import { PrenoteHistoryComponent } from './components/company-info/prenote-history/prenote-history.component';
import { AppRoutes } from './shared/constants/app-routes';

export interface RouteData {
  entitlements?: string[];
  header: Partial<Header>;
}

export const routes: Routes = [
  {path: '', component: AuthComponent, outlet: 'eepay'},
  {
    path: 'alertsdetails', component: AlertsDetailsComponent, canActivate: [AuthGuard],
    data: {
      entitlements: Entitlements.AlertsAndNotifications,
      header: {
        pageTitle: 'ALERTS.PAGE_TITLE',
        pageTooltip: 'ALERTS.PAGE_TITLE',
        breadcrumb: 'ALERTS.ALERTS_BREADCRUMB',
        breadcrumbs: ['dashboard'],
        ultiProHelpPageName: 'Alerts and Notifications'
      }
    } as RouteData,
    outlet: 'eepay'
  },
  {path: 'callback', component: AuthCallbackComponent, outlet: 'eepay'},
  {
    path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard, RouterPopstatePreventer],
    data: {
      entitlements: Entitlements.ViewEmployeePay,
      header : {
        pageTitle: 'COMMON.PAGE_TITLE',
        breadcrumb: 'COMMON.DASHBOARD_BREADCRUMB',
        ultiProHelpPageName: 'Payment Services'
      },
    } as RouteData,
    outlet: 'eepay'
  },
  {
    path: 'payinfo', component: PayInfoComponent, canActivate: [AuthGuard],
    data: {
      entitlements: Entitlements.QuickActions,
      header: {
        pageTitle: 'EMPLOYEE_PAYS.PAGE_TITLE_EMPLOYEE_PAYS',
        breadcrumb: 'EMPLOYEE_PAYS.PAGE_TITLE_EMPLOYEE_PAYS',
        breadcrumbs: ['dashboard'],
        ultiProHelpPageName: 'Employee Pays'
      },
    } as RouteData,
    outlet: 'eepay'
  },
  {
    path: 'staledatedchecksinfo', component: StaleDatedChecksInfoComponent, canActivate: [AuthGuard],
    data: {
      entitlements: Entitlements.QuickActions,
      header: {
        pageTitle: 'STALE_DATED_CHECKS.PAGE_TITLE_STALE_DATED_CHECKS',
        breadcrumb: 'STALE_DATED_CHECKS.PAGE_TITLE_STALE_DATED_CHECKS',
        breadcrumbs: ['dashboard'],
        ultiProHelpPageName: 'View Stale Dated Checks'
      },
    } as RouteData,
    outlet: 'eepay'
  },
  {
    path: 'viewcompanies', component: CompanyInfoComponent, canActivate: [AuthGuard],
    data: {
      entitlements: Entitlements.ViewCompanies,
      header: {
        pageTitle: 'COMPANIES.PAGE_TITLE_SEND_PRENOTE_FILE',
        breadcrumb: 'COMPANIES.PAGE_TITLE_SEND_PRENOTE_FILE',
        breadcrumbs: ['dashboard'],
        ultiProHelpPageName: 'Send Prenote File'
      },
    } as RouteData,
    outlet: 'eepay'
  },
  {
    path: 'prenotehistory', component: PrenoteHistoryComponent, canActivate: [AuthGuard],
    data: {
      entitlements: Entitlements.ViewCompanies,
      header: {
        pageTitle: 'COMPANIES.PAGE_TITLE_PRENOTE_HISTORY',
        breadcrumb: 'COMPANIES.PAGE_TITLE_PRENOTE_HISTORY',
        breadcrumbs: ['viewcompanies'],
        ultiProHelpPageName: 'View Prenote History'
      },
    } as RouteData,
    outlet: 'eepay'
  },
  {
    path: 'error/:status', component: ErrorComponent,
    data: {
      header: {
        pageTitle: 'COMMON.PAGE_TITLE',
        ultiProHelpPageName: 'Payment Services'
      }
    } as RouteData,
    outlet: 'eepay'
  },
  {
    path: AppRoutes.UnauthorizedQualifiers, component: UnauthorizedQualifiersComponent,
    data: {
      header: {
        pageTitle: 'COMMON.PAGE_TITLE',
        ultiProHelpPageName: 'Payment Services'
      }
    } as RouteData,
    outlet: 'eepay'
  },
  {path: 'logout', component: LogoutComponent, outlet: 'eepay'},
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [HttpClientModule, ElementRoutingModule.withRoutes(routes, {})], // if you want to enable router tracing, enable environment.enableRouterTracing
  providers: [RouterPopstatePreventer],
  exports: [ElementRoutingModule]
})
export class AppRoutingModule {
}
